import { Dispatch, SetStateAction, useCallback, useState } from "react";

interface ISetters {
    setTrue(): void;
    setFalse(): void;
    toggle(): void;
}

export type IUseBoolean = [boolean, Dispatch<SetStateAction<boolean>>, ISetters];

export function useBoolean(initialValue = false): IUseBoolean {
    const [value, setValue] = useState(initialValue);
    const setTrue = useCallback((): void => setValue(true), []);
    const setFalse = useCallback((): void => setValue(false), []);
    const toggle = useCallback((): void => setValue((v) => !v), []);

    return [value, setValue, { setTrue, setFalse, toggle }];
}
